import React from 'react'

const Terms = () => {
  return (
    <div className="min-h-screen bg-white py-16 px-6">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl font-bold text-slate-900 mb-8">Terms and Conditions</h1>
        <div className="prose prose-slate max-w-none">
          {/* <p className="text-lg text-slate-600 mb-6">Last updated: {new Date().toLocaleDateString()}</p> */}

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-900 mb-4">Acceptance of Terms</h2>
            <p className="text-slate-600 mb-4">By accessing or using Tutor Match AE, you agree to these Terms and
              Conditions. If you do not agree, please do not use the platform.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-900 mb-4">The Platform</h2>
            <p className="text-slate-600 mb-4">Tutor Match AE is a marketplace that connects families with independent
              tutors. Tutors listed on the platform are not employees of Tutor Match AE,
              and we do not provide tutoring services directly.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-900 mb-4">User Responsibilities</h2>
            <p className="text-slate-600 mb-4">You are responsible for providing accurate information, keeping your
              account details secure, and using the platform in a lawful and respectful
              manner.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-900 mb-4">Bookings and Payments</h2>
            <p className="text-slate-600 mb-4">Payments and bookings are handled through the platform to support
              transparency for families and tutors. Tutor Match AE does not guarantee
              learning outcomes and is not responsible for the content or delivery of
              tutoring sessions.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-900 mb-4">Platform Availability</h2>
            <p className="text-slate-600 mb-4">We aim to keep the platform available and functioning smoothly, but
              uninterrupted access cannot be guaranteed at all times.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-900 mb-4">Limitation of Liability</h2>
            <p className="text-slate-600 mb-4">Tutor Match AE is not liable for indirect or consequential losses arising
              from the use of the platform, to the extent permitted by law.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-900 mb-4">Changes to These Terms</h2>
            <p className="text-slate-600 mb-4">We may update these Terms and Conditions from time to time. Continued
              use of the platform indicates acceptance of any changes.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-900 mb-4">Contact Us</h2>
            <p className="text-slate-600">If you have questions about these Terms and Conditions, you can contact
              us directly.</p>
          </section>
        </div>
      </div>
    </div>
  )
}

export default Terms;